import { createAction, createReducer } from 'redux-act';

import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  messages: [],
});

export const addMessage = createAction('ADD_MESSAGE');
export const removeMessageByIndex = createAction('REMOVE_MESSAGE_BY_INDEX');
export const removeMessagesByType = createAction('REMOVE_MESSAGES_BY_TYPE');

const reducers = createReducer({
  [addMessage]: (state, message) => {
    const oldMessages = state.messages;
    const messages = oldMessages.concat(message);
    return state.merge({ messages });
  },
  [removeMessageByIndex]: (state, index) => {
    const messages = state.messages.asMutable();
    messages.splice(index, 1);
    return state.merge({ messages });
  },
  [removeMessagesByType]: (state, type) => {
    const messages = state.messages.filter(message => message.type !== type);
    return state.merge({ messages });
  },
}, INITIAL_STATE);

export default reducers;
